import { Component, Inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import * as app from '../../app.selector';
import * as applications from '../../modules/applications/application.selector';
import * as card from '../../modules/card/card.selector';
import * as history from '../../modules/history-requests/history-requests.selector';
import * as consent from '../../modules/consent/consent.selector';
import { selectAuthenticationLoading } from '../../modules/url-params/url-params.selector';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/combineLatest';

/**
 * Container component to show loading screen.
 */
@Component({
    selector: 'ssf-loading-screen',
    template: `
        <ssf-spinner
            [show]="(selectLoadingStatus$ | async)?.length > 0 || show">
        </ssf-spinner>

        <div *ngIf="debug">
            <div *ngFor="let status of (selectLoadingStatus$ | async)">
                {{status}}
            </div>
        </div>
    `
})
export class LoadingScreenComponent {
    selectLoadingStatus$: Observable<string[]>;
    @Input() show: boolean;

    constructor(private store: Store<AppState>, @Inject('debug') public debug: boolean) {

        this.selectLoadingStatus$ = Observable.combineLatest(
            this.store.select(app.selectLoadingStatus),
            this.store.select(applications.selectLoadingStatus),
            this.store.select(card.selectLoadingStatus),
            this.store.select(history.selectLoadingStatus),
            this.store.select(consent.selectLoadingStatus),
            this.store.select(selectAuthenticationLoading))
            .map(([app, apps, card, history, consent, auth]:
                      ([string[], string[], string[], string[], string[], boolean])) => [
                    ...app,
                    ...apps,
                    ...card,
                    ...history,
                    ...consent,
                    ...(auth ? ['auth'] : [] )
                ].filter(s => !!s)
            );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/loading-screen/loading-screen.component.ts